<template>
  <!-- 
    Components: 割引プラン会員一覧
    用途: 割引プランに関連する会員一覧を表示する
  -->
  <div>

    <CCard>

      <!-- #region 検索クエリ -->
      <CCardHeader>
        <h3 class="card-title mb-3">割引プラン会員一覧</h3>
        <p>
          検索条件を選択し、割引プラン対象の会員を検索してください。
        </p>
        <CForm
          class="search-filter"
          onsubmit="return false;"
        >

          <CRow class="mb-2">

            <CCol
              lg="12"
              class="search-btn "
            >
              <!-- #region 検索条件選択 -->
              <label class="">検索条件</label>
              <CSelect
                class="search-lbl"
                :options="queryOptions"
                :value.sync="selectedQuery"
              />
              <!-- #endregion 検索条件選択 -->

              <!-- #region すべて検索 -->
              <template v-if="isSelectedQuery('all')">

                <CButton
                  @click="onSearchClicked('all')"
                  class="info-button w-100"
                >
                  <i class="icon cil-search"></i> 検索
                </CButton>
              </template>
              <!-- #endregion すべて検索 -->
            </CCol>

          </CRow>

          <!-- #region カードID検索 -->
          <template v-if="isSelectedQuery('cardId')">
            <CRow class="mb-2">
              <CCol
                sm="7"
                lg="5"
              >
                <div class="form-group form-row m-0">
                  <label class="col-form-label col-sm-3">カードID</label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="カードIDを入力（部分一致）"
                      v-model="convertId"
                      @keydown.enter="onSearchQueryEnter($event, 'cardId')"
                    />
                    <small class="form-text text-muted w-100">カードIDには5桁以上の値を入力してください</small>
                  </div>
                </div>
              </CCol>

              <CCol
                sm="3"
                lg="2"
              >
                <CButton
                  @click="onSearchClicked('cardId')"
                  class="info-button w-100"
                  :disabled="$v.query.cardId.$invalid"
                >
                  <i class="icon cil-search"></i> 検索
                </CButton>
                <!-- 検索 -->
              </CCol>
            </CRow>
          </template>
          <!-- #endregion カードID検索 -->

          <!-- #region ユーザ名検索  -->
          <template v-if="isSelectedQuery('username')">
            <CRow class="mb-2">
              <CCol
                sm="7"
                lg="5"
              >
                <CInput
                  label="ユーザ名"
                  class="search-input"
                  placeholder="ユーザ名を入力して検索してください（完全一致）"
                  horizontal
                  v-model="query.username"
                  @keydown.enter="onSearchQueryEnter($event, 'username')"
                  type="tel"
                />
              </CCol>
              <CCol
                sm="3"
                lg="2"
              >
                <CButton
                  @click="onSearchClicked('username')"
                  class="info-button w-100"
                  :disabled="!query.username"
                >
                  <i class="icon cil-search"></i> 検索
                </CButton>
                <!-- 検索 -->
              </CCol>
            </CRow>
          </template>
          <!-- #endregion ユーザ名検索  -->

          <!-- #region 氏名検索 -->
          <template v-if="isSelectedQuery('name')">
            <CRow class="mb-2">
              <CCol
                sm="7"
                lg="5"
              >
                <CInput
                  label="氏名"
                  class="search-input"
                  placeholder="氏名または氏名(カナ)を入力して検索してください（部分一致）"
                  horizontal
                  v-model="query.name"
                  @keydown.enter="onSearchQueryEnter($event, 'name')"
                />
              </CCol>
              <CCol
                sm="3"
                lg="2"
              >
                <CButton
                  @click="onSearchClicked('name')"
                  class="info-button w-100"
                  :disabled="!query.name"
                >
                  <i class="icon cil-search"></i> 検索
                </CButton>
              </CCol>
            </CRow>
          </template>
          <!-- #endregion 氏名検索 -->

          <!-- #region Eメールアドレス検索 -->
          <template v-if="isSelectedQuery('email')">
            <CRow class="mb-2">
              <CCol
                sm="7"
                lg="5"
              >
                <CInput
                  label="Eメールアドレス"
                  class="search-input"
                  placeholder="Eメールアドレスを入力して検索してください（部分一致）"
                  horizontal
                  v-model="query.email"
                  @keydown.enter="onSearchQueryEnter($event, 'email')"
                  type="email"
                />
              </CCol>
              <CCol
                sm="3"
                lg="2"
              >
                <CButton
                  @click="onSearchClicked('email')"
                  class="info-button w-100"
                  :disabled="!query.email"
                >
                  <i class="icon cil-search"></i> 検索
                </CButton>
              </CCol>
            </CRow>
          </template>
          <!-- #endregion Eメールアドレス検索 -->

          <!-- #region 郵便番号検索 -->
          <template v-if="isSelectedQuery('zipcode')">
            <CRow class="mb-2">
              <CCol
                sm="7"
                lg="5"
              >
                <CInput
                  label="電話番号"
                  class="search-input"
                  placeholder="電話番号を入力して検索してください（部分一致）"
                  horizontal
                  v-model="query.phone"
                  @keydown.enter="onSearchQueryEnter($event, 'phone')"
                  type="tel"
                />
              </CCol>
              <CCol
                sm="3"
                lg="2"
              >
                <CButton
                  @click="onSearchClicked('phone')"
                  class="info-button w-100"
                  :disabled="!query.phone"
                >
                  <i class="icon cil-search"></i> 検索
                </CButton>
              </CCol>
            </CRow>
          </template>
          <!-- #endregion 郵便番号検索 -->

          <!-- #region 電話番号検索 -->
          <template v-if="isSelectedQuery('phone')">
            <CRow class="mb-2">
              <CCol
                sm="7"
                lg="5"
              >
                <CInput
                  label="郵便番号"
                  class="search-input"
                  placeholder="郵便番号を入力して検索してください（前方一致）"
                  horizontal
                  v-model="query.zipcode"
                  @keydown.enter="onSearchQueryEnter($event, 'zipcode')"
                  type="tel"
                />
              </CCol>
              <CCol
                sm="3"
                lg="2"
              >
                <CButton
                  @click="onSearchClicked('zipcode')"
                  class="info-button w-100"
                  :disabled="!query.zipcode"
                >
                  <i class="icon cil-search"></i> 検索
                </CButton>
              </CCol>
            </CRow>
          </template>
          <!-- #endregion 郵便番号検索 -->

          <!-- #region 住所検索 -->
          <template v-if="isSelectedQuery('address')">
            <CRow class="mb-2">
              <CCol
                sm="7"
                lg="5"
              >
                <CInput
                  label="住所"
                  class="search-input"
                  placeholder="住所を入力して検索してください（部分一致）"
                  description="データ量が多いため検索に時間がかかる可能性があります。"
                  horizontal
                  v-model="query.address"
                  @keydown.enter="onSearchQueryEnter($event, 'address')"
                  type="tel"
                />
              </CCol>
              <CCol
                sm="3"
                lg="2"
              >
                <CButton
                  @click="onSearchClicked('address')"
                  class="info-button w-100"
                  :disabled="!query.address"
                >
                  <i class="icon cil-search"></i> 検索
                </CButton>
              </CCol>
            </CRow>
          </template>
          <!-- #endregion 住所検索 -->

          <transition name="fade">
            <CRow v-if="notFound">
              <CCol lg="6">
                <CAlert color="danger">会員が見つかりませんでした。</CAlert>
              </CCol>
            </CRow>
          </transition>
        </CForm>
      </CCardHeader>
      <!-- #endregion 検索クエリ -->

      <!-- #region 検索結果一覧 -->
      <CCollapse
        :show="true"
        :duration="200"
      >
        <CCardBody>
          <div class="user-info-table">
            <dl class="row">
              <dt class="col-sm-12">
                <h4 class="sub-title">会員一覧</h4>
                会員総数: {{totalUserCount}} | 検索数: {{userCount}}
              </dt>
            </dl>
            <CDataTable
              class="mb-0 table-outline"
              hover
              size="sm"
              :items="users"
              :fields="tableFields"
              head-color="light"
              table-filter
              column-filter
              sorter
              itemps-per-page-select
              :items-per-page="100"
              pagination
              v-if="!loading"
            >
              <td
                slot="cardId"
                class="text-left"
                slot-scope="{ item }"
              >
                {{ item.cardId }}
              </td>
              <td
                slot="name"
                slot-scope="{ item }"
              >
                {{ userDisplayName(item) }}
              </td>
              <td
                slot="activated"
                slot-scope="{ item }"
                class="text-center"
              >
                {{ item.activated | formatDate }}
              </td>
              <td
                slot="validateSince"
                slot-scope="{ item }"
                class="text-center"
              >
                {{ item.validateSince | formatDate }}
              </td>
              <td
                slot="validateUntil"
                slot-scope="{ item }"
                class="text-center"
              >
                {{ item.validateUntil | formatDate }}
              </td>
              <td
                slot="count"
                slot-scope="{ item }"
                class="text-right"
              >
                {{ item.count }}
              </td>
              <td
                slot="used"
                slot-scope="{ item }"
                class="text-right"
              >
                {{ item.used }}
              </td>
              <td
                slot="remainCount"
                slot-scope="{ item }"
                class="text-right"
              >
                {{ remainCount(item) }}
              </td>
              <template #memberDiscountList="{ item }">
                <td class="py-2 text-center">
                  <CButton
                    color="info"
                    square
                    block
                    size="sm"
                    @click="onMemberDiscountListClicked(item.userid)"
                  >割引一覧</CButton>
                </td>
              </template>
            </CDataTable>
          </div>
        </CCardBody>
      </CCollapse>
      <!-- #endregion 検索結果一覧 -->

    </CCard>

    <!-- #region Alert -->
    <CAlert
      color="danger"
      class="mt-3 text-center"
      v-if="notFound"
    >
      条件に該当する会員はいません。
    </CAlert>
    <!-- #endregion Alert -->

    <!-- #region Modal -->
    <!-- #endregion Modal -->

  </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "DiscountMemberListTable",

  props: {},

  data() {
    return {

      //#region Flag

      // canSearch: false,
      // notFound: false,
      collapse: false,
      loading: false,
      errorModal: false,
      loadingsvg: require("../../assets/loading.svg"),
      collapseDuration: 0,
      /** 検索済みか？ */
      searched: false,
      errors: "",

      //#endregion Flag

      query: {
        cardId: "",
        username: "",
        name: "",
        email: "",
        phone: "",
        zipcode: "",
        address: "",
      },

      //#region Table

      /** 会員総数 */
      totalUserCount: 0,

      /** 一覧列名 */
      tableFields: [
        { key: "cardId", label: "カードID", _classes: "text-center bg-light" },
        { key: "name", label: "氏名 (カナ)", _classes: "text-center bg-light" },
        {
          key: "activated",
          label: "購入日",
          _classes: "text-center bg-light",
        },
        { key: "validateSince", label: "	開始日", _classes: "text-center bg-light" },
        { key: "validateUntil", label: "	終了日", _classes: "text-center bg-light" },
        {
          key: "count",
          label: "使用回数上限",
          _classes: "text-center bg-light",
        },
        {
          key: "used",
          label: "使用回数",
          _classes: "text-center bg-light",
        },
        {
          key: "remainCount",
          label: "残使用回数",
          _classes: "text-center bg-light",
        },
        {
          key: "memberDiscountList",
          label: "割引一覧",
          sorter: false,
          filter: false,
          _classes: "text-center bg-light",
        },
      ],

      /** 一覧表示データ */
      tableItems: [],

      /** 検索条件選択 */
      queryOptions: [
        { value: "all", label: "すべて" },
        { value: "cardId", label: "カードID" },
        { value: "username", label: "ユーザ名" },
        { value: "name", label: "氏名" },
        { value: "email", label: "Eメールアドレス" },
        { value: "phone", label: "電話番号" },
        { value: "zipcode", label: "郵便番号" },
        { value: "address", label: "住所" },
      ],

      /** 選択中の検索条件 */
      selectedQuery: "all",

      //#endregion Table


      //#region Response data

      /** 会員一覧 */
      users: [],

      //#endregion Response data

    }
  },

  validations: {
    query: { cardId: { required, minLength: minLength(5) } },
  },

  computed: {

    /** 一覧表表示できるか？ */
    canShowTable() {
      return !this.loading && !this.notFound;
    },

    /** レスポンスデータが見つからないか？ */
    notFound() {
      return this.searched && this.users.length < 1;
    },

    /** ユーザーUUIDがあるか？ */
    hasUuid() {
      console.log(this.uuid);
      return !this.uuid !== "";
    },

    /** ユーザーUUID */
    uuid() {
      return this.$route.params.uuid;
    },

    /** ログインユーザーのロール */
    loginUserRoles() {
      return this.$keycloak.realmAccess.roles;
    },

    /** 許可されているか */
    isAllowed() {
      if (!this.hasUuid) return false;
      if (this.loginUserRoles.includes('liberty_operator_admin')) return true;
      if (this.loginUserRoles.includes('liberty_operator')) return true;
      return false;
    },

    /** 会員検索数 */
    userCount() {
      return this.users.length;
    },

    /** 割引プランID(UUID) */
    discountId() {
      return this.$route.params.uuid;
    },

    /** カードID変換 */
    convertId: {
      get() {
        return this.query.cardId;
      },
      set(value) {
        var conv = value.replace(/[\uff01-\uff5e]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
        });
        this.query.cardId = conv;
      },
    },
  },

  methods: {

    //#region Event

    /** 割引一覧ボタン押下 */
    onMemberDiscountListClicked(uuid) {
      // 「会員割引一覧」に遷移
      this.$router.push({ path: `/member-discount-list/${uuid}` });
    },

    /** 検索ボタン押下・検索クエリ入力テキストEnterキー押下 */
    onSearchClicked(value) {
      this.getSearchQuery(value);
      this.searched = true;
    },

    /** 検索ボタン押下・検索クエリ入力テキストEnterキー押下 */
    onSearchQueryEnter(event, value) {
      if (!this.validateQuery(event, value)) return;
      this.getSearchQuery(value);
      this.searched = true;
    },

    //#endregion Event


    //#region Request

    /**
     * 会員検索
     * @param value クエリタイプ
     */
    getSearchQuery: function (value) {
      const discountId = this.discountId;
      let url = `/rest/discounts/${discountId}/users`;

      // TODO: API開発後に修正
      switch (value) {
        case "all":
          url = `${url}`;
          break;
        case "cardId":
          url = `${url}?card=${this.query[value]}`;
          break;
        case "username":
          url = `${url}/${this.query[value]}`;
          break;
        default:
          // Note: case ["name", "email", "phone", "zipcode", "address"]
          url = `${url}?${value}=${this.query[value]}`;
          break;
      }

      console.log(url);

      this.loading = true;
      this.users = [];

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          if (value == "username") {
            // ユーザ名検索のresp.dataは1件固定のため、usersにpushする
            this.users.push(resp.data);
          } else {
            this.users = resp.data;
          }

          console.log("User Data:" + JSON.stringify(this.users));
          this.loading = false;
          this.collapse = true;

          this.users == ""
            ? ((this.collapse = false), (this.notFound = true))
            : ((this.collapse = true), (this.notFound = false));
        })
        .catch((err) => {
          console.log(err);
          this.notFound = true;

          this.loading = false;
          this.collapse = false;
        });
    },

    /** 会員割引一覧取得 */
    getUserDiscounts() {
      if (!this.isAllowed) return;

      const uuid = this.uuid;
      // FIXME: discountsが正式。API修正待ち。
      // const url = `/rest/users/uuid/${uuid}/discounts`;
      const url = `/rest/users/uuid/${uuid}/discount`;

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          const datas = resp.data;
          console.log(datas);

          this.discounts = datas;

          // 取得データを一覧表に流し込み
          this.pourTable(datas);
          console.log(this.tableItems);

          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.PassError = err.response.status;
          this.loading = false;
        });
    },

    /** 全会員数を取得 */
    getTotalUsersCount: function () {
      var url = "/rest/users/";
      this.loading = true;
      axios
        .get(url, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.totalUserCount = resp.data;
          console.log("User Data:" + JSON.stringify(this.totalUserCount));
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.notFound = true;
          this.loading = false;
        });
    },

    //#endregion Request

    //#region Method

    /**
     * 検索クエリを検証
     */
    validateQuery(event, value) {
      // 日本語入力中のEnterキー操作は無効
      if (event.keyCode === 229) return false;
      // if (event.keyCode !== 13) return false;

      if (!value) return false;
      if (!this.query[value]) return false;

      return true;
    },

    /** 選択中の検索クエリか？ */
    isSelectedQuery(query) {
      return this.selectedQuery === query;
    },

    /** 会員表示用名称 */
    userDisplayName(user) {
      return `${user.familyName} ${user.givenName} (${user.lastName} ${user.firstName})`;
    },

    /** 残使用回数 */
    remainCount(item) {
      return item.count - item.used;
    },

    /**
     * 一覧表にデータを流し込む
     * @param datas
     */
    pourTable(datas) {
      this.clearTable();
      datas.forEach(data => {
        this.tableItems.push(
          {
            // note: data.coupon = 割引プランのオプション
            shortCode: data.shortCode,
            name: data.coupon.name,
            type: data.coupon.type,
            value: data.coupon.value,
            description: data.coupon.description,
            status: data.status,
            activated: data.activated,
            count: data.count,
            used: data.used,
            remainCount: data.count - data.used,
          }
        );
      });
    },

    /**
     * 一覧表をクリア
     */
    clearTable() {
      this.tableItems = [];
    },

    //#endregion Method

  },

  beforeMount() {
    this.getTotalUsersCount();
  },

};
</script>
